import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Media } from '../../../../../theme/Media';
import Icons from '../../../../Elements/Icons';
import { DropdownList as UIDropdownList } from '../../../DropdownList';
import { ActionButton } from '../ActionButton';
export const DropdownList = memo(function DropdownList({ zIndex = 10, buttonLabel = 'More', isLoading, buttonDataTestId, ...restProps }) {
    const isMobile = useMediaQuery({ query: Media.xsMax });
    return (_jsx(UIDropdownList, { zIndex: zIndex, isLoading: isLoading, renderButton: (isShown) => (_jsxs(ActionButton, { dataTestId: buttonDataTestId, disabled: restProps.disabled, isLoading: isLoading, children: [_jsx(Icons.More, { size: 20, active: isShown }), isMobile && buttonLabel] })), ...restProps }));
});
